/* eslint-disable camelcase */
import { graphql, useStaticQuery } from "gatsby";

// todo: more reliable filter strategy to exclude myDIRTT resources
// allStoryblokEntry(filter: { full_slug: { regex: "/projects/(.*)/" } }) {
const useNews = () => {
  // ---------------------------------------------------------------------------
  // static data

  const { allStoryblokEntry } = useStaticQuery(graphql`
    {
      allStoryblokEntry(filter: { full_slug: { regex: "^/media/.*/" } }) {
        edges {
          node {
            id
            uuid
            name
            path
            position
            slug
            lang
            group_id
            full_slug
            content
            created_at
            published_at
          }
        }
      }
    }
  `);

  // ---------------------------------------------------------------------------
  // variables

  const data = !allStoryblokEntry?.edges?.[0]
    ? []
    : allStoryblokEntry.edges.map(({ node }) => ({
        ...node,
        content: JSON.parse(node.content)
      }));

  // ---------------------------------------------------------------------------
  // methods

  const getNewsArticles = () => {
    if (!data?.[0]) {
      return [];
    }

    const filteredResults = data?.filter(
      (item) => item?.content?.component?.toLowerCase() === `news`
    );

    return filteredResults;
  };

  const getRecentNews = (limit = 2) => {
    if (!data?.[0]) {
      return [];
    }

    const filteredResults = data?.filter(
      (item) => item?.content?.component?.toLowerCase() === `news`
    );

    // Sort by published_at date (most recent first) and limit results
    const sortedResults = filteredResults
      .slice()
      .sort((a, b) => new Date(b.published_at) - new Date(a.published_at))
      .slice(0, limit);

    return sortedResults;
  };

  return {
    data,
    getNewsArticles,
    getRecentNews
  };
};

export default useNews;
